// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3074":"378b6646","8514":"378b6646","8930":"378b6646"}[chunkId] + ".chunk.css";
};